<template>
  <SideBar />
  <div class="p-4 sm:ml-64 min-h-screen bg-gray-900 text-white">
    
    <!-- <ClientTableComponent /> -->
    <!-- Aquí se renderiza el componente -->
     <RowComponent
      v-for="cliente in clientes"
      :key="cliente.ID"
      :data="cliente"
      :h1="[cliente.Nombre]"
      :h2="[
        cliente.Comentarios || null,
        cliente.Telefono ? `Tel: ${cliente.Telefono}` : null,
        cliente.Direccion ? `Dir: ${cliente.Direccion}` : null
      ].filter(Boolean)"/>
  </div>
</template>

<script>
// import ClientTableComponent from "../components/ClientTableComponent.vue";
import ClientesProvider from "@/helpers/providers/ClientesProvider";
import SideBar from "../components/NavBar.vue";
import RowComponent from "@/components/RowComponent.vue";

export default {
  name: "ClientesPage",
  data() {
    return {
      clientes: [],
    };
  },
  components: {
    // ClientTableComponent,
    SideBar, // Register the imported component here
    RowComponent,
  },
  async mounted() {
    this.$notiflix.Loading.standard();
    this.clientes = await ClientesProvider.getClientes();
    this.$notiflix.Loading.remove();
  },
};
</script>
